import React, { useMemo } from 'react';
import { connect, MapStateToProps } from 'react-redux';
import { compose } from '@reduxjs/toolkit';

import { DatetimeFormatType, TypeOfDate } from 'app/lib/datetime/types';
import { ReduxState } from 'app/redux/types';

import { withinBettingContext } from 'app/contexts/betting';
import Datetime from 'app/design-system/components/Datetime';
import { accessMainScore, MainScores } from 'app/lib/betting/accessMatchDetails';
import { MatchStatus, SlotType } from 'app/lib/betting/betting-entities';
import { TeamId } from 'app/lib/betting/constants';
import { getMatchInformationComponent } from 'app/modules/Betting';

import styles from './MatchItem.module.scss';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type BettingContextProps = any;

type StoreProps = {
  sportId: number;
  startDate: string;
  mainScores: MainScores;
  isLive: boolean;
  isMatchNotStarted: boolean;
};

type Props = {
  matchId: number;
};

const MatchDetails: React.FC<Props & StoreProps> = ({
  matchId,
  sportId,
  startDate,
  mainScores,
  isLive,
  isMatchNotStarted,
}) => {
  const MatchTime = useMemo(() => (
    getMatchInformationComponent(sportId, isMatchNotStarted)
  ), [isMatchNotStarted]);

  return (
    <div className={styles.matchDetails}>
      {isLive
        ? (
          <>
            <MatchTime matchId={matchId} />

            {(mainScores && !isMatchNotStarted) &&(
              <p className={styles.matchScores}>
                {`${mainScores.get(TeamId.FIRST, '–')} : ${mainScores.get(TeamId.SECOND, '–')}`}
              </p>
            )}
          </>
        )
        : (
          <Datetime value={startDate}
                    format={DatetimeFormatType.FRIENDLY}
                    typeOfDate={TypeOfDate.HUMAN_DATE}
                    className={styles.matchTime} />
        )
      }
    </div>
  );
};

const mapStateToProps: MapStateToProps<
  StoreProps,
  Props & BettingContextProps,
  ReduxState
> = (
  state, {
    $betting: {
      content: {
        selectors: { matches },
      },
    },
    matchId,
  },
): StoreProps => {
  const match = matches(state).get(matchId);
  const isLive = match?.slotType === SlotType.LIVE;
  const isMatchNotStarted = isLive && match.status === MatchStatus.NOT_STARTED;

  return {
    mainScores: accessMainScore(match),
    startDate: match?.startDate,
    sportId: match?.sportId,
    isLive,
    isMatchNotStarted,
  };
};

export default compose<React.FC<Props>>(
  withinBettingContext,
  connect(mapStateToProps),
)(MatchDetails);

